import { useGetDealOptions } from '~/api/deals';
import { deliverableTypes } from '~/schemas/deals';

export function useDealOptions() {
  const { data: options } = useGetDealOptions();

  return {
    deliverableTypes,
    options,
  };
}
